export default "__VITE_ASSET__BtuCWpGO__"